//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractRoomContentNavModel, AbstractRoomContentModel } from "@app/catalog-common";

import { 
  debouncedSignal, 
  PresenterRegistration, 
  SignalWrapper 
} from "@app/shared";


@PresenterRegistration({
  types: [AbstractRoomContentNavModel],
  key: "subMenu",
})
@Component({
  selector: "room-contents-submenu",
  standalone: false,
  templateUrl: "./room-contents-submenu.component.html",
  styleUrl: "./room-contents-submenu.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomContentsSubmenuComponent<TRoom extends AbstractRoomContentModel> {
  public data: WritableSignal<AbstractRoomContentNavModel<TRoom>> = signal<AbstractRoomContentNavModel<TRoom>>(null);

  /**
   * @summary Filter for items
   * @description: Creates a debounce signal to ensure reduction of filtering
   */
  public roomsFilter = SignalWrapper.create({
    coreSignal: signal<string>(null), 
    overrideSignalFn: (coreSignal) => debouncedSignal(coreSignal, 600)
  });
  
  /**
   * @summary Gets rooms, if a search is applied, the result is filtered by the criteria   
   */
  public filteredRooms = computed(() => {
    let rooms = this.data()?.items();
    if (!rooms) return [];

    let searchValue = this.roomsFilter.overrideSignal();
    if (!searchValue) return rooms; 
    
    return rooms.filter(r => r.value?.fullName()?.toLowerCase().includes(searchValue.toLowerCase()));
  });   
}
